import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, ActivationEnd } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { filter } from 'rxjs/operators';
import * as $ from 'jquery';
import { AppServiceService } from '../../app/main/services/product.service';
import { MainMenuService } from '../../app/main/services/menuservice.service';
import { HotkeysService, Hotkey } from 'angular2-hotkeys';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../app/shared/services/Utility.service';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mr-header',
  template: require('./mr-header.html'),
})
export class MRHeaderComponent implements OnInit {
  isCollapsed = true;
  menu = [
    {
      title: 'Home',
      link: '/home',
    },
    {
      title: 'About Us',
      link: '/aboutus',
    },
  ];
  Router;
  isAdmin: boolean = false;
  isLoggedIn: boolean = false;
  AuthService;
  UserId: any = 0;
  UnitId: any = 0;
  CurrentFYear: any = 0;
  id_token: any = '';
  public myText: any;
  userObj: any;
  public breadcrumbList: Array<any> = [];
  ApiBusy: Subscription | undefined;
  public dataTitle: any;

  swalWithBootstrapButtons = Swal.mixin({
    confirmButtonClass: 'btn btn-success',
    cancelButtonClass: 'btn btn-danger',
    buttonsStyling: false,
});

  toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    backdrop: `rgba(30, 30, 37, 0.4)`,
  });

  toastWarningMsg(options: any) {
    if (typeof options == 'object') {
      this.toast({
        type: 'warning',
        showConfirmButton: options.confirm_btn,
        timer: options.timer,
        title: options.msg,
      });
    } else {
      this.toast({
        type: 'warning',
        title: options,
      });
    }
  }

  static parameters = [
    AuthService,
    Router,
    ActivatedRoute,
    AppServiceService,
    HotkeysService,
    HttpClient,
    MainMenuService,
    UtilityService,
  ];
  constructor(
    private authService: AuthService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private service: AppServiceService,
    private hotkeysService: HotkeysService,
    private http: HttpClient,
    private menuService: MainMenuService,
    public utilityService: UtilityService
  ) {
    this.http = http;
    this.AuthService = authService;
    this.hotkeysService = hotkeysService;
    this.Router = router;
    this.activatedRoute = activatedRoute;
    this.service = service;
    this.reset();
    this.Router.events
      .pipe(
        filter(
          (event, router) =>
            event instanceof ActivationEnd &&
            event.snapshot.children.length == 0
        )
      )
      .subscribe((event: any) => {
        this.dataTitle = event.snapshot.data;
        $('div.modal-backdrop.fade.show').remove();
        this.Router.events.subscribe((router: any) => {
          let routerUrl: string, routerList: Array<any>;
          routerUrl = router.urlAfterRedirects;
          if (routerUrl && typeof routerUrl === 'string') {
            this.breadcrumbList.length = 0;
            routerList = routerUrl.slice(1).split('/');
            var filtered = routerList.filter(function (item) {
              return !(parseInt(item) == item);
            });
            filtered.forEach((router, index, path) => {
              this.breadcrumbList.push({
                name: router,
                path: routerUrl,
                title: this.dataTitle.title,
                maintitle: this.dataTitle.maintitle,
              });
            });
          }
        });
      });
  }

  per: any;
  ngOnInit() {
    let parent = this;
    setTimeout(() => {
      if (localStorage.getItem('permission')) {
        this.per = JSON.parse(localStorage.getItem('permission') as any)[0];
        if (this.per.colorTheme !== undefined && this.per.colorTheme !== '') {
          $('body').addClass(this.per.colorTheme);
        }
        if (this.per.fontTheme !== undefined && this.per.fontTheme !== '') {
          $('body').addClass(this.per.fontTheme);
        }
        this.service.getFooterDetails();
      }

      $(document).ready(function () {
        // $(window).on("unload", function(e) {
        //     //alert("call");
        //     localStorage.removeItem('id_token');
        //     localStorage.removeItem('user');
        //     localStorage.removeItem('permission');
        // });

        $('.dropdown').on('show.bs.dropdown', function (e: any) {
          $(this)
            .find('.dropdown-menu')
            .first()
            .stop(true, true)
            .slideDown(400);
        });
        $('.dropdown').on('hide.bs.dropdown', function (e: any) {
          $(this).find('.dropdown-menu').first().stop(true, true).slideUp(300);
        });
      });
    }, 500);

    this.menuService.MenuListmyMethodSubject.subscribe(response => {
      this.allMenus = response;
    });
    this.menuService.UserPermissionmyMethodSubject.subscribe(
      (Permission: any) => {
        if (Permission.length == 0) {
          return;
        }
        this.UserId = Permission[0]['_id'];
        this.UnitId = Permission[0]['Unit_ID'];
        this.CurrentFYear = Permission[0]['CurrentFYear'];
        this.id_token = localStorage.getItem('id_token');
      }
    );
  }

  public allMenus: any = [];
  updatefirstletter(val: any, id: string) {
    // debugger
    var i = 0;
    if (val == 'Payroll') {
      i = val.toString().indexOf('y');
    }
    if (i == 0) {
      $('#first_' + id).text('');
      $('#second_' + id).text(val[i]);
      $('#third_' + id).text(val.substring(i + 1, val.length));
    } else {
      $('#first_' + id).text(val.substring(0, i));
      $('#second_' + id).text(val[i]);
      $('#third_' + id).text(val.substring(i + 1, val.length));
    }
    return '';
  }

  reset() {
    this.userObj = {};
    this.AuthService.isLoggedIn().then(is => {
      this.isLoggedIn = is;
    });
    setTimeout(() => {
      if (localStorage.getItem('user')) {
        this.userObj = JSON.parse(localStorage.getItem('user') as any);
      }
    }, 1000);
  }

  logout() {
    return this.AuthService.logout().then(() => {
      this.Router.navigateByUrl('/login');
      localStorage.clear();
      this.reset();
      this.service.getFooterDetails();
      this.service.footerDataSubject.next('');
      setTimeout(() => {
        this.service.footerDataTable.subscribe(res => {
          this.per = res;
        });
      }, 600);
    });
  }

  reloadBrowser() {
    Swal({
      title: 'Reload Window?',
      text: 'All the changes will be lost!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm',
      customClass: 'swal-warning-custom',
    }).then((result: any) => {
      if (result.value) {
        location.reload();
      }
      return;
    });
  }

  launchCalc() {
    window.open('Calculator:///');
  }
}
